import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6e1ea21e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "page"
};
var _hoisted_2 = {
  class: "pageContent"
};
import Header from "@/components/Header/index.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Header), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view)])]);
    };
  }
});